import { createContext } from "react";

import type { Messages } from "./types";

export interface I18nContextValue {
  locale: string;
  messages: Messages;
  changeLocale: (nextLocale: string) => void;
  showLanguageSwitcher: boolean;
  availableLocales: string[];
}

export const I18nContext = createContext<I18nContextValue | null>(null);
